import React, { Fragment, useEffect, useState } from 'react';
import GuarantorSwitchBox from './GuarantorSwitchBox';
import { Badge, Button, Col, Input, Popover, Radio, Row } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { ServerAPI } from '../../common/ServerAPI';
import { toast } from 'react-toastify';
import {
  UploadOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileZipOutlined,
  DownloadOutlined,
  DownCircleOutlined,
  EditOutlined,
} from '@ant-design/icons';
import { IMAGE_BASE_URL } from '../../common/Constants';
import {
  downloadDocuments,
  downloadDocumentsUnzip,
  handleDownload,
  objToArray,
} from '../../common/Utilities';
import EditSignatureUpload from '../LoanApplication/EditSignatureUpload';

const GuarantorDetails = ({
  guarantorType,
  data,
  reloadData,
  selectGaurantor,
  comp,
}) => {
  const { setDocumentPreview, setDocumentUrl, fileType } = comp;
  let TabObj = [];
  const location = useLocation();
  const [selectedGuarantor, setSelectedGuarantor] = useState(0);
  const [guarantorDocuments, setGuarantorDocuments] = useState([]);
  const [guarantoraction, setGuarantorAction] = useState('');
  const [rejectionReason, setRejectionReason] = useState('');
  const [documentRequest, setDocumentRequest] = useState('');
  const [fileDocumentType, setFileDocumentType] = useState('');
  const [downloadPopOver, setDownloadPopOver] = useState(false);
  const [guranSign, setGuranSign] = useState(true);
  const navigate = useNavigate();
  const { TextArea } = Input;
  const type = location?.state?.type ?? 'guarantor';


  if (data != undefined) {
    const guarantorTabData = data.map((guarantorData, idx) => {
      TabObj.push({
        name: 'Guarantor ' + (idx + 1),
        dataIndex: idx,
        sign_status: guarantorData?.guarantor_docs?.guarantor_signature?.[0]
          ? 'yes'
          : 'no',
      });
    });
  }

  const MakeAvailable = async (id) => {
    const response = await ServerAPI.MakeAvailable(id);
    if (response) {
      toast.success(response.message);
      setGuarantorAction('');
      reloadData();
    }
  };

  const handleOpenChange = (newOpen) => {
    setDownloadPopOver(newOpen);
  };

  const updateGuarantorStatus = async () => {
    if (data[selectedGuarantor] != undefined) {
      let obj = {
        loan_application: localStorage.getItem('applicationId'),
        guarantor: data[selectedGuarantor]?.id,
        rejected: guarantoraction == 'reject' ? 1 : 0,
        reason_for_rejection: rejectionReason,
        document_requested: guarantoraction == 'request' ? 1 : 0,
        description: documentRequest != '' ? documentRequest : '',
      };

      const response = await ServerAPI.updateGuarantorStatus(obj);
      setGuarantorAction('');
      toast.success(response.message);
      reloadData();
    }
  };
  const handleDocumentstofurnish = (value) => {
    setDocumentRequest(value);
  };

  useEffect(() => {
    selectGaurantor(selectedGuarantor);
    let dataDocuments = [];
    if (data != undefined) {
      dataDocuments = objToArray(data[selectedGuarantor]?.guarantor_docs);

      dataDocuments.map((item) => {
        const isSignExist = Object.keys(item).includes('guarantor_signature') || item?.guarantor_signature !== "";
        if (isSignExist) {
          setGuranSign(false);
        } else {
          setGuranSign(true);
        }
      });
      setGuarantorDocuments(dataDocuments);
    }
  }, [selectedGuarantor, data]);

  return data != undefined && data[selectedGuarantor] != undefined ? (
    <div>
      <GuarantorSwitchBox tabs={TabObj} handler={setSelectedGuarantor} />
      {guarantorType == 'rejected' && (
        <p className='text-[12px] font-[400] text-[#FD4954] mb-3'>
          Rejected Reason -{' '}
          {
            data[selectedGuarantor]?.guarantor_status_update[
            'reason_for_rejection'
            ]
          }
        </p>
      )}
      <Fragment>
        <div className='preview-list-block'>
          <div className='preview-list-group'>
            <div className='preview-list'>
              <h3>Applying As:</h3>
              <p className='capitalize'>
                {data[selectedGuarantor].guarantor_type === 'individual'
                  ? data[selectedGuarantor].guarantor_citizenship_type
                  : data[selectedGuarantor].guarantor_type}
              </p>
            </div>
            <div className='preview-list'>
              <h3>Title:</h3>
              <p>
                {data[selectedGuarantor].personal_details?.title
                  ? data[selectedGuarantor].personal_details?.title
                  : data[selectedGuarantor].personal_details?.company_title}
              </p>
            </div>
            <div className='preview-list'>
              <h3>Name:</h3>
              <p>
                {data[selectedGuarantor].personal_details?.name
                  ? data[selectedGuarantor].personal_details?.name
                  : data[selectedGuarantor].personal_details?.company_name}
              </p>
            </div>
            <div className='preview-list'>
              <h3>Email:</h3>
              <p>{data[selectedGuarantor].personal_details?.email}</p>
            </div>
            {data[selectedGuarantor].personal_details?.gender && (
              <div className='preview-list'>
                <h3>Gender:</h3>
                <p>{data[selectedGuarantor].personal_details?.gender}</p>
              </div>
            )}
            {data[selectedGuarantor].personal_details?.nationality && (
              <div className='preview-list'>
                <h3>Nationality/Country:</h3>
                <p> {data[selectedGuarantor].personal_details?.nationality}</p>
              </div>
            )}
            {data[selectedGuarantor].personal_details?.passport_expiry_date && (
              <div className='preview-list'>
                <h3>Passport Expiry:</h3>
                <p>
                  {
                    data[selectedGuarantor].personal_details
                      ?.passport_expiry_date
                  }
                </p>
              </div>
            )}
            {data[selectedGuarantor].personal_details?.office && (
              <div className='preview-list'>
                <h3>Office No:</h3>
                <p>{data[selectedGuarantor].personal_details?.office}</p>
              </div>
            )}
            {data[selectedGuarantor].personal_details?.home_no && (
              <div className='preview-list'>
                <h3>Home No:</h3>
                <p>{data[selectedGuarantor].personal_details?.home_no}</p>
              </div>
            )}

            <div className='preview-list'>
              <h3>Address:</h3>
              <p>
                {data[selectedGuarantor].personal_details?.home_address != ""
                  ? data[selectedGuarantor].personal_details?.home_address
                  : data[selectedGuarantor].personal_details?.company_address}
              </p>
            </div>
            <div className='preview-list'>
              <h3>Postal Code:</h3>
              <p>
                {data[selectedGuarantor].personal_details?.postal_code != ""
                  ? data[selectedGuarantor].personal_details?.postal_code
                  : data[selectedGuarantor].personal_details?.company_postal_code}
              </p>
            </div>
            {data[selectedGuarantor]?.guarantor_type === "individual" ? (
              <>
                <div className='preview-list'>
                  <h3>Mailing Address:</h3>
                  <p>
                    {data[selectedGuarantor].personal_details
                      ?.home_address_same_as_mailing == 0
                      ? data[selectedGuarantor].personal_details
                        ?.mailing_home_address
                      : data[selectedGuarantor].personal_details
                        ?.home_address}
                  </p>
                </div>
                <div className='preview-list'>
                  <h3>Mailing Post Code:</h3>
                  <p>
                    {data[selectedGuarantor].personal_details
                      ?.home_address_same_as_mailing == 0
                      ? data[selectedGuarantor].personal_details
                        ?.mailing_postal_code
                      : data[selectedGuarantor].personal_details
                        ?.postal_code}
                  </p>
                </div>
                <div className='preview-list'>
                  <h3>Mailing Residence Type:</h3>
                  <p>
                    {data[selectedGuarantor].personal_details
                      ?.home_address_same_as_mailing == 0
                      ? data[selectedGuarantor].personal_details
                        ?.mailing_residence_type
                      : data[selectedGuarantor].personal_details
                        ?.residence_type}
                  </p>
                </div>
              </>
            ) : (
              <>
                <div className='preview-list'>
                  <h3>Company Mailing Address:</h3>
                  <p>
                    {data[selectedGuarantor].personal_details
                      ?.company_address_same_as_mailing == 0
                      ? data[selectedGuarantor].personal_details
                        ?.mailing_company_address
                      : data[selectedGuarantor].personal_details
                        ?.company_address}
                  </p>
                </div>
                <div className='preview-list'>
                  <h3>Company Mailing Postal Code:</h3>
                  <p>
                    {data[selectedGuarantor].personal_details
                      ?.company_address_same_as_mailing == 0
                      ? data[selectedGuarantor].personal_details
                        ?.mailing_company_postal_code
                      : data[selectedGuarantor].personal_details
                        ?.company_postal_code}
                  </p>
                </div>
              </>
            )}

            {data[selectedGuarantor]?.guarantor_type == 'individual' &&
              data[selectedGuarantor]?.guarantor_nric != '' && (
                <div className='preview-list'>
                  <h3>NRIC No:</h3>
                  <p>{data[selectedGuarantor]?.guarantor_nric}</p>
                </div>
              )}
            {data[selectedGuarantor].personal_details?.uen_acra_no != '' && (
              <div className='preview-list'>
                <h3>UEN/ACRA No:</h3>
                <p>{data[selectedGuarantor].personal_details?.uen_acra_no}</p>
              </div>
            )}
            {data[selectedGuarantor].personal_details?.dob && (
              <div className='preview-list'>
                <h3>Date of Birth:</h3>
                <p>{data[selectedGuarantor].personal_details?.dob}</p>
              </div>
            )}
            {data[selectedGuarantor].personal_details
              ?.date_of_incorporation && (
                <div className='preview-list'>
                  <h3>Date of Incorporation:</h3>
                  <p>
                    {
                      data[selectedGuarantor].personal_details
                        ?.date_of_incorporation
                    }
                  </p>
                </div>
              )}
            {data[selectedGuarantor].personal_details?.marital_status && (
              <div className='preview-list'>
                <h3>Marital Status:</h3>
                <p>
                  {data[selectedGuarantor].personal_details?.marital_status}
                </p>
              </div>
            )}
            {data[selectedGuarantor].personal_details?.name_of_spouse && (
              <div className='preview-list'>
                <h3>Name of Spouse:</h3>
                <p>
                  {data[selectedGuarantor].personal_details?.name_of_spouse}
                </p>
              </div>
            )}
            {data[selectedGuarantor].personal_details?.residence_type && (
              <div className='preview-list'>
                <h3>Residence:</h3>
                <p>
                  {data[selectedGuarantor].personal_details?.residence_type}
                </p>
              </div>
            )}
            {data[selectedGuarantor].personal_details?.mobile_no && (
              <div className='preview-list'>
                <h3>Mobile No:</h3>
                <p>{data[selectedGuarantor].personal_details?.mobile_no}</p>
              </div>
            )}
          </div>
        </div>
        <>
          {data[selectedGuarantor]?.employement_details &&
            data[selectedGuarantor]?.employement_details?.employment_type !=
            'Unemployed' ? (
            <div className='preview-list-block'>
              <div className='preview-list-group'>
                <div className='preview-list'>
                  <h3>Employment:</h3>
                  <p>
                    {data[selectedGuarantor]?.employement_details?.employment_type?.trim()
                      ? data[selectedGuarantor].employement_details.employment_type
                      : 'Unemployed'}
                  </p>
                </div>
                <div className='preview-list'>
                  <h3>Type of Industry:</h3>
                  <p>
                    {
                      data[selectedGuarantor]?.employement_details
                        ?.type_of_industry
                    }
                  </p>
                </div>
                <div className='preview-list'>
                  <h3>Occupation:</h3>
                  <p>
                    {data[selectedGuarantor]?.employement_details?.occupation}
                  </p>
                </div>
                <div className='preview-list'>
                  <h3>Income Type:</h3>
                  <p>
                    {data[selectedGuarantor]?.employement_details?.finance_type}
                  </p>
                </div>
                <div className='preview-list'>
                  <h3>Monthly Income:</h3>
                  <p>
                    $
                    {
                      data[selectedGuarantor]?.employement_details
                        ?.monthly_income
                    }
                  </p>
                </div>
                <div className='preview-list'>
                  <h3>Other Monthly Income:</h3>
                  <p>
                    $
                    {data[selectedGuarantor]?.employement_details?.other_income}
                  </p>
                </div>
                <div className='preview-list'>
                  <h3>Employer Name:</h3>
                  <p>
                    {
                      data[selectedGuarantor]?.employement_details
                        ?.employer_name
                    }
                  </p>
                </div>
                <div className='preview-list'>
                  <h3>Employer Address:</h3>
                  <p>
                    {
                      data[selectedGuarantor]?.employement_details
                        ?.employer_address
                    }
                  </p>
                </div>
                <div className='preview-list'>
                  <h3>Length of Service:</h3>
                  <p>
                    {
                      data[selectedGuarantor]?.employement_details
                        ?.service_duration_years
                    }{' '}
                    years{' '}
                    {
                      data[selectedGuarantor]?.employement_details
                        ?.service_duration_months
                    }{' '}
                    months
                  </p>
                </div>
                <div className='preview-list'>
                  <h3>Prev. Occupation:</h3>
                  <p>
                    {data[selectedGuarantor]?.employement_details
                      ?.employer_previous_occupation
                      ? data[selectedGuarantor]?.employement_details
                        ?.employer_previous_occupation
                      : '-'}
                  </p>
                </div>
                <div className='preview-list'>
                  <h3>Prev. Employer Name:</h3>
                  <p>
                    {data[selectedGuarantor]?.employement_details
                      ?.employer_previous_name
                      ? data[selectedGuarantor]?.employement_details
                        ?.employer_previous_name
                      : '-'}
                  </p>
                </div>
                <div className='preview-list'>
                  <h3>Prev. Employer Address:</h3>
                  <p>
                    {data[selectedGuarantor]?.employement_details
                      ?.employer_previous_address
                      ? data[selectedGuarantor]?.employement_details
                        ?.employer_previous_address
                      : '-'}
                  </p>
                </div>
                <div className='preview-list'>
                  <h3>Prev. Length of Service:</h3>
                  <p>
                    {data[selectedGuarantor]?.employement_details
                      ?.employer_previous_experience_years
                      ? data[selectedGuarantor]?.employement_details
                        ?.employer_previous_experience_years
                      : '0'}{' '}
                    years{' '}
                    {data[selectedGuarantor]?.employement_details
                      ?.employer_previous_experience_months
                      ? data[selectedGuarantor]?.employement_details
                        ?.employer_previous_experience_months
                      : '0'}{' '}
                    months
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <>
              {data[selectedGuarantor]?.employement_details !== null && (
                <div className='preview-list'>
                  <h3>Employment:</h3>
                  <p>
                    <p>
                      {
                        data[selectedGuarantor]?.employement_details
                          ?.employment_type
                      }
                    </p>
                  </p>
                </div>
              )}
            </>
          )}
        </>
        <Row gutter={[24, 0]}>
          <Col xs={24} sm={24} md={12} lg={12} className=''>
            <p className='mt-5 text-[15px] font-[600]'>Document(s) Uploaded </p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} className='text-right'>
            <div className='justify-between items-center mb-2'>
              <Popover
                content={
                  <div>
                    <Button
                      type='primary'
                      onClick={() => {
                        downloadDocuments(type, data[0]?.id);
                      }}
                      className='min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex w-[155px] mb-2'
                    >
                      <FileZipOutlined className='mr-2 mt-1' />
                      <p>Download Zip</p>
                    </Button>
                    <Button
                      type='primary'
                      onClick={() => {
                        downloadDocumentsUnzip(type, data[0]?.id);
                      }}
                      className='min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex w-[155px]'
                    >
                      <DownloadOutlined className='mr-2 mt-1' />
                      <p>Download Files</p>
                    </Button>
                  </div>
                }
                placement='bottom'
                trigger='hover'
                open={downloadPopOver}
                onOpenChange={handleOpenChange}
              >
                <Button
                  className=' mt-4 min-[768px]:text-[14px] max-[768px]:text-[12px]'
                  type='primary'
                >
                  Download All Documents
                </Button>
              </Popover>
            </div>
          </Col>
          <Row gutter={[16, 16]} className='mb-1 mt-4'>
            {guarantorDocuments != undefined && guarantorDocuments.length > 0 && (
              <>
                {guarantorDocuments.map((doc, index) => {
                  const key = Object.keys(doc)[0];
                  let words = key.split('_');
                  for (let i = 0; i < words.length; i++) {
                    words[i] =
                      words[i].charAt(0).toUpperCase() + words[i].slice(1);
                  }
                  let result = words.join(' ');
                  if (result.length <= 4) {
                    result = result.toUpperCase();
                  }
                  // Determine if a new row should start
                  const shouldStartNewRow = index > 0 && index % 4 === 0;
                 
                  return (
                    <>
                      {shouldStartNewRow && (
                        <div style={{ flexBasis: '100%', height: 0 }}></div>
                      )}
                      <Col>
                        <div className='sm:w-2/2 lg:w-4/4 mt-1 flex py-2 w-[250px] px-2'>
                          <img
                            style={{ width: '15px', height: '15px' }}
                            className='mr-3 mt-[2px]'
                            src={'/images/' + key + '.png'}
                          />
                          <div className='w-full flex'>
                            <div className='text-[13px] font-[500] text-[#0D062D]'>
                              {result === 'NAO' ? 'NOA' : result}
                            </div>
                          </div>
                        </div>
                        {doc[key]?.map((data) => {
                          let valType = false;
                          let imgType = '';
                          if (typeof data === 'object') {
                            valType = true;
                            let popType = data.value.split('.').pop();
                            if (popType === 'pdf') {
                              imgType = 'pdf';
                            }

                          }
                          return (
                            <Fragment>
                              <div className='sm:w-2/2 lg:w-4/4 mt-1 flex border rounded py-2 w-full px-2'>
                                {imgType === 'pdf' ? (
                                  <FilePdfOutlined className='pdfOutlineStyle' />
                                ) : imgType === 'docx' ? (
                                  <FileWordOutlined className='pdfOutlineStyle' />
                                ) : (
                                  <img
                                    style={{ width: '50px', height: '50px' }}
                                    className='mr-3 mt-[2px]'
                                    src={
                                      valType
                                        ? IMAGE_BASE_URL + data.value
                                        : IMAGE_BASE_URL + data
                                    }
                                  />
                                )}
                                <div className='w-full flex justify-between mt-4'>
                                  <div className='text-[13px] font-[500] text-[#0D062D] whitespace-nowrap truncate max-w-[150px]'>
                                    {valType ? data.name : data.split('/').pop()}
                                  </div>
                                  <div>
                                    <div className='text-right'>
                                      <img
                                        src='/images/document_download.png'
                                        alt='Download Document'
                                        className='max-w-xs cursor-pointer ml-auto'
                                        onClick={() => {
                                          setDocumentPreview(true);
                                          setDocumentUrl(
                                            valType ? data.value : data
                                          );
                                          fileType(valType ? data.value : data);
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className='w-full flex justify-between items-center mt-1'>
                                <p className='text-left font-lato text-[12px] text-[500] text-instruction-grey opacity-60 mt-1'></p>
                              </div>
                            </Fragment>
                          );
                        })}
                        <div></div>
                      </Col>
                    </>
                  );
                })}
                {(data[selectedGuarantor]?.documents?.guarantor_signature === "" || data[selectedGuarantor]?.documents?.company_stamp === "") && (
                  <div className='w-full'>
                    <EditSignatureUpload
                      type='guarantor'
                      activeGuarantor={selectedGuarantor}
                      updateFunction={() => reloadData()}
                    />
                  </div>
                )}
              </>
            )}
          </Row>
        </Row>

      </Fragment>
    </div>
  ) : (
    <div className='text-center'>No Guarantors Available</div>
  );
};

export default GuarantorDetails;
{ /**  */ }